import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import {
  dismissCommandFailure,
  selectCommandFailure,
} from '../store/slices/commandFailureSlice';
import { flexBoxCenter } from '../styles/commonStyles';
import { resyncDevices } from '../../helpers/resyncDevices';
import { logger } from '../../helpers/logger';
import MessageBox from './messageBox';

const CommandFailureMessage = () => {
  const failure = useSelector(selectCommandFailure);
  const dispatch = useDispatch();
  const failureId = failure?.id;
  const failedSystem = failure?.system;
  const failedMacs = failure?.macs;

  const resync = () =>
    resyncDevices(dispatch, failedSystem, failedMacs).catch((error) =>
      logger.warn('could not resync devices after a failed command', error),
    );

  useEffect(() => {
    if (!failureId) {
      return;
    }
    resync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [failureId, failedSystem, failedMacs, dispatch]);

  if (!failure) {
    return null;
  }

  return (
    <Overlay>
      <MessageBox
        title='command failed'
        messages={[`command not delivered to ${failure.device}`, failure.reason]}
        onClose={() => {
          resync();
          dispatch(dismissCommandFailure());
        }}
      />
    </Overlay>
  );
};

export default CommandFailureMessage;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 10001;
  ${flexBoxCenter};
`;
